import React from 'react';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import AddressWithInformationByEntityTypeSelect from '../BaseInputs/Selectors/AddressWithInformationByEntityTypeSelect';
import CountrySelect from '../BaseInputs/Selectors/CountrySelect';
import CurrencySelect from '../BaseInputs/Selectors/CurrencySelect';
import ClientSelect from '../BaseInputs/Selectors/ClientSelect';
import SurveySelect from '../BaseInputs/Selectors/SurveySelect';
import ServiceSelect from '../BaseInputs/Selectors/ServiceSelect';
import WaveSelect from '../BaseInputs/Selectors/WaveSelect';
import TpRunSelect from '../BaseInputs/Selectors/TpRunSelect';
import OfficeSelect from '../BaseInputs/Selectors/OfficeSelect';
import BilledOfficeSelect from '../BaseInputs/Selectors/BilledOfficeSelect';
import OutsourcedActivityOfficeSelect from '../BaseInputs/Selectors/OutsourcedActivityOfficeSelect';
import OfficeDetailsGroupSelect from '../BaseInputs/Selectors/OfficeDetailsGroupSelect';
import OfficeGroupSelect from '../BaseInputs/Selectors/OfficeGroupSelect';
import OfficeOrGroupSelect from '../BaseInputs/Selectors/OfficeOrGroupSelect';
import PaymentOfficeSelect from '../BaseInputs/Selectors/PaymentOfficeSelect';
import OpportunityStatusChangeSelect from '../BaseInputs/Selectors/OpportunityStatusChangeSelect';
import PricingStatusChangeSelect from '../BaseInputs/Selectors/PricingStatusChangeSelect';
import UserSelect from '../BaseInputs/Selectors/UserSelect';
import UserSelectWithGuid from '../BaseInputs/Selectors/UserSelectWithGuid';
import OutsourcedUserSelect from '../BaseInputs/Selectors/OutsourcedUserSelect';
import LeadSelect from '../BaseInputs/Selectors/LeadSelect';
import PrimaryFreelancerUserSelect from '../BaseInputs/Selectors/PrimaryFreelancerUserSelect';
import ContactSelect from '../BaseInputs/Selectors/ContactSelect';
import InvoiceBillToContactSelect from '../BaseInputs/InvoiceBillToContactSelect';
import JobsNoLongerReadyChoiceSelect from '../BaseInputs/JobsNoLongerReadyChoiceSelect';
import ProjectManagerSelect from '../BaseInputs/Selectors/ProjectManagerSelect';
import TrueFalseLookupItemSelect from '../BaseInputs/Selectors/TrueFalseLookupItemSelect';
import ProjectOpportunitySelect from '../BaseInputs/Selectors/ProjectOpportunitySelect';
import OpportunitySelect from '../BaseInputs/Selectors/OpportunitySelect';
import ProjectServiceSelect from '../BaseInputs/Selectors/ProjectServiceSelect';
import ProjectSelect from '../BaseInputs/Selectors/ProjectSelect';
import NewProjectSelect from '../BaseInputs/Selectors/NewProjectSelect';
import ActiveGroupSelect from '../BaseInputs/Selectors/ActiveGroupSelect';
import CreditMemoRequestInvoiceSelect from '../BaseInputs/Selectors/CreditMemoRequestInvoiceSelect';
import TpCreditMemoTpClientInvoiceSelect from '../BaseInputs/Selectors/TpCreditMemoTpClientInvoiceSelect';
import CreditMemoRequestStatusChangeSelect from '../BaseInputs/Selectors/CreditMemoRequestStatusChangeSelect';
import PaymentRequestStatusChangeSelect from '../BaseInputs/Selectors/PaymentRequestStatusChangeSelect';
import TpPaymentRequestStatusChangeSelect from '../BaseInputs/Selectors/TpPaymentRequestStatusChangeSelect';
import ClientForReportSelect from '../BaseInputs/Selectors/ClientForReportSelect';
import ProjectForReportSelect from '../BaseInputs/Selectors/ProjectForReportSelect';
import CommissionUserSelect from '../BaseInputs/Selectors/CommissionUserSelect';
import ExternalSalesPartnerSelect from '../BaseInputs/Selectors/ExternalSalesPartnerSelect';
import ThirdPartySourceSelect from '../BaseInputs/Selectors/ThirdPartySourceSelect';
import FreelancerUserManagerSelect from '../BaseInputs/Selectors/FreelancerUserManagerSelect';
import SourceSelect from '../BaseInputs/Selectors/SourceSelect';
import TpSurveySelect from '../BaseInputs/Selectors/TpSurveySelect';
import TpEvaluatorSelect from '../BaseInputs/Selectors/TpEvaluatorSelect';
import TpSurveyByClientAndInstanceSelect from '../BaseInputs/Selectors/TpSurveyByClientAndInstanceSelect';
import TpWaveSelect from '../BaseInputs/Selectors/TpWaveSelect';
import SourceQuestionSelect from '../BaseInputs/Selectors/SourceQuestionSelect';
import ApolloLanguageLocaleSelect from '../BaseInputs/Selectors/ApolloLanguageLocaleSelect';
import FileUploadField from '../BaseInputs/FileUploadField';
import PillSelect from '../../DesignSystem/PillSelect';

export const renderSelectAddressWithInformationByEntityType = (props) => (
  <AddressWithInformationByEntityTypeSelect
    EntityTypeId={props.EntityTypeId}
    EntityId={props.EntityId}
    fieldName={props.fieldName}
    showSelectFilterAt={props.showSelectFilterAt}
    filterCleared={props.filterCleared}
    value={props.value}
    onChange={(value) => props.onChange(props.fieldName, value)}
  />
);

export const renderCountrySelect = (props) => (
  <CountrySelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
    useCountryCode={props.type === InputTypesEnum.CountryCodeSelect}
    useCountryName={props.type === InputTypesEnum.CountryNameSelect}
  />
);

export const renderCurrencySelect = (props) => (
  <CurrencySelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
    showSelectFilterAt={props.showSelectFilterAt}
    editedItem={props.editedItem}
    IsCheckBoxEnabled={props.IsCheckBoxEnabled}
    selectValues={props.selectValues}
    onlyActive={props.type === InputTypesEnum.ActiveCurrencySelect}
  />
);

export const renderClientSelect = (props) => (
  <ClientSelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
    showSelectFilterAt={props.showSelectFilterAt}
  />
);

export const renderSurveySelect = (props) => (
  <SurveySelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
    idFilter={props.idFilter}
  />
);

export const renderServiceSelect = (props) => (
  <ServiceSelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
    idFilter={props.idFilter}
    onlyActive={props.type === InputTypesEnum.ActiveServiceSelect}
  />
);

export const renderWaveSelect = (props) => (
  <WaveSelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
    idFilter={props.idFilter}
  />
);

export const renderTpRunSelect = (props) => (
  <TpRunSelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
    idFilter={props.idFilter}
  />
);

export const renderOfficeSelect = (props) => (
  <OfficeSelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
    editedItem={props.editedItem}
    IsCheckBoxEnabled={props.IsCheckBoxEnabled}
    changeOfEditedMultipItem={props.changeOfEditedMultipItem}
    idFilter={props.idFilter}
    showSelectFilterAt={props.showSelectFilterAt}
  />
);

export const renderBilledOfficeSelect = (props) => (
  <BilledOfficeSelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
    changeOfEditedMultipItem={props.changeOfEditedMultipItem}
    startDate={props.startDate}
    onNoFteEntries={props.onNoFteEntries}
    userOfficeName={props.userOfficeName}
  />
);

export const renderOutsourcedActivityOfficeSelect = (props) => (
  <OutsourcedActivityOfficeSelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
    changeOfEditedMultipItem={props.changeOfEditedMultipItem}
    labelling={props.labelling}
  />
);

export const renderOfficeDetailsGroupSelect = (props) => (
  <OfficeDetailsGroupSelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
    editedItem={props.editedItem}
  />
);

export const renderOfficeGroupSelect = (props) => (
  <OfficeGroupSelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
  />
);

export const renderOfficeOrGroupSelect = (props) => (
  <OfficeOrGroupSelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
    isMulti={props.type !== InputTypesEnum.OfficeOrGroupSelect}
    forReport={props.type === InputTypesEnum.OfficeOrGroupForReportMultiSelect}
    selectAllOnLoad={props.placeholder === 'select_all'}
  />
);

export const renderPaymentOfficeSelect = (props) => (
  <PaymentOfficeSelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
    editedItem={props.editedItem}
    IsCheckBoxEnabled={props.IsCheckBoxEnabled}
    changeOfEditedMultipItem={props.changeOfEditedMultipItem}
    idFilter={props.idFilter}
  />
);

export const renderOpportunityStatusChangeSelect = (props) => (
  <OpportunityStatusChangeSelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
    EntityId={props.EntityId}
  />
);

export const renderPricingStatusChangeSelect = (props) => (
  <PricingStatusChangeSelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
    idFilter={props.idFilter}
  />
);

export const renderUserSelect = (props) => (
  <UserSelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
    active={props.type === InputTypesEnum.ActiveUserSelect}
  />
);

export const renderUserSelectWithGuid = (props) => (
  <UserSelectWithGuid
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
    active={props.type === InputTypesEnum.ActiveUserSelectWithGuid}
  />
);

export const renderOutsourcedUserSelect = (props) => (
  <OutsourcedUserSelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
    changeOfEditedMultipItem={props.changeOfEditedMultipItem}
  />
);

export const renderLeadSelect = (props) => (
  <LeadSelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
  />
);

export const renderPrimaryFreelancerUserSelect = (props) => (
  <PrimaryFreelancerUserSelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
    officeId={props.idFilter}
  />
);

export const renderContactSelect = (props) => (
  <ContactSelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
    idFilter={props.idFilter}
    onlyActive={props.type !== InputTypesEnum.ContactSelect}
    onlyWithAddress={props.type === InputTypesEnum.ContactSelectForNewInvoice}
    showEmailInLabel={props.type === InputTypesEnum.ActiveContactSelectWithEmail}
  />
);

/** An invoice's bill-to contact, with the tax number, bill-to name and office it brings (InvoiceBillToContactSelect). */
export const renderInvoiceBillToContactSelect = (props) => (
  <InvoiceBillToContactSelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
    idFilter={props.idFilter}
    editedItem={props.editedItem}
  />
);

/** What to do with the shops no longer ready for invoicing, with those shops listed under it (JobsNoLongerReadyChoiceSelect). */
export const renderJobsNoLongerReadyChoiceSelect = (props) => (
  <JobsNoLongerReadyChoiceSelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
    editedItem={props.editedItem}
  />
);

export const renderProjectManagerSelect = (props) => (
  <ProjectManagerSelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
    editedItem={props.editedItem}
  />
);

export const renderTrueFalseLookupItemSelect = (props, lookupId) => (
  <TrueFalseLookupItemSelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
    lookupId={lookupId}
  />
);

export const renderProjectOpportunitySelect = (props) => (
  <ProjectOpportunitySelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
    multipleIdFilter={props.multipleIdFilter}
  />
);

export const renderOpportunitySelect = (props) => (
  <OpportunitySelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
    idFilter={props.idFilter}
  />
);

export const renderProjectServiceSelect = (props) => (
  <ProjectServiceSelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
    idFilter={props.idFilter}
  />
);

export const renderClientFeeSelect = (props) => (
  <ProjectSelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
    idFilter={props.idFilter}
    onlyActive={props.type === InputTypesEnum.ActiveClientFeeSelect}
  />
);

export const renderProjectSelect = (props) => (
  <NewProjectSelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
    idFilter={props.idFilter}
    onlyActive={props.type === InputTypesEnum.ActiveProjectSelect}
  />
);

export const renderActiveGroupSelect = (props) => (
  <ActiveGroupSelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
    idFilter={props.idFilter}
  />
);

export const renderCreditMemoRequestInvoiceSelect = (props) => (
  <CreditMemoRequestInvoiceSelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
    idFilter={props.idFilter}
  />
);

export const renderTpCreditMemoTpClientInvoiceSelect = (props) => (
  <TpCreditMemoTpClientInvoiceSelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
    idFilter={props.idFilter}
  />
);

export const renderCreditMemoRequestStatusChangeSelect = (props) => (
  <CreditMemoRequestStatusChangeSelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
    EntityId={props.EntityId}
  />
);

export const renderPaymentRequestStatusChangeSelect = (props) => (
  <PaymentRequestStatusChangeSelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
    EntityId={props.EntityId}
  />
);

export const renderTpPaymentRequestStatusChangeSelect = (props) => (
  <TpPaymentRequestStatusChangeSelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
    EntityId={props.EntityId}
  />
);

export const renderClientForReportSelect = (props) => (
  <ClientForReportSelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
    idFilter={props.idFilter}
  />
);

export const renderProjectForReportSelect = (props) => (
  <ProjectForReportSelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
    idFilter={props.idFilter}
  />
);

export const renderCommissionUserSelect = (props) => (
  <CommissionUserSelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
  />
);

export const renderExternalSalesPartnerSelect = (props) => (
  <ExternalSalesPartnerSelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
    onlyActive={props.type === InputTypesEnum.ActiveExternalSalesPartnerSelect}
  />
);

export const renderThirdPartySourceSelect = (props) => (
  <ThirdPartySourceSelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
    idFilter={props.idFilter}
    multipleIdFilter={props.multipleIdFilter}
  />
);

export const renderThirdPartySourceTpClientLinkSelect = (props) => (
  <ThirdPartySourceSelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
    idFilter={props.idFilter}
    multipleIdFilter={props.multipleIdFilter}
    forTpClientLinking={true}
  />
);

export const renderFreelancerUserManagerSelect = (props) => (
  <FreelancerUserManagerSelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
    multipleIdFilter={props.multipleIdFilter}
  />
);

export const renderSourceSelect = (props) => (
  <SourceSelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
  />
);

export const renderTpSurveySelect = (props) => (
  <TpSurveySelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
    idFilter={props.idFilter}
  />
);

export const renderTpSurveyByClientAndInstanceSelect = (props) => (
  <TpSurveyByClientAndInstanceSelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
    multipleIdFilter={props.multipleIdFilter}
  />
);

export const renderTpWaveSelect = (props) => (
  <TpWaveSelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
    idFilter={props.idFilter}
  />
);

export const renderTpEvaluatorSelect = (props) => (
  <TpEvaluatorSelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
    editedItem={props.editedItem}
  />
);

export const renderSourceQuestionSelect = (props) => (
  <SourceQuestionSelect
    value={props.value}
    fieldName={props.fieldName}
    onChange={props.onChange}
    selectValues={props.selectValues}
    placeholder={props.placeholder}
    numberOfRows={props.numberOfRows}
  />
);

export const renderApolloLanguageLocaleSelect = (props) => (
  <ApolloLanguageLocaleSelect
    value={props.value}
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    filterCleared={props.filterCleared}
    showSelectFilterAt={props.showSelectFilterAt}
    editedItem={props.editedItem}
    IsCheckBoxEnabled={props.IsCheckBoxEnabled}
  />
);

export const renderFileUploadField = (props) => (
  <FileUploadField
    onChange={(value, fieldName) => props.onChange(fieldName ?? props.fieldName, value)}
    acceptedTypes={props.acceptedTypes}
    className={props.className}
    rawFileFieldName={props.rawFileFieldName}
    fileTemplateFunction={props.fileTemplateFunction}
  />
);

export const renderPillSelect = (props) => (
  <PillSelect
    options={props.selectValues ?? props.selectvalues ?? []}
    value={props.value}
    onChange={(newValue) => props.onChange(props.fieldName, newValue)}
  />
);
